// Google Ads — Competitors campaign config
// Traffic: people searching "hotel chocolat alternative", "tony chocolonely alternative", etc.
// Mindset: cold, doesn't know Barnaby, comparison shopping. Lead with product credibility and provenance.

window.adConfigs = window.adConfigs || {};

window.adConfigs['google-competitors'] = {
  subtitle: 'Handmade in London. Real ingredients.',
  socialProof: '★★★★★ My new favourite chocolate',
  carousel: [
    'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Self_Treat_Caramel.png?v=1776269836',
    'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Craving_Raspberry_3.png?v=1776243690',
    'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Hand_held_bar_with_logo_for_scale_carousel.png?v=1777448524',
    'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Barnaby_10thDec-5274_Brighter_Shadow.png?v=1774431167',
  ]
};